import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { type IVerticalArrowProps } from 'shared/components/VerticalArrow';

import styles from './Arrow.css';

export const Arrow: FC<IVerticalArrowProps> = ({ direction, containerClass, onClick }) => {
  const ArrowIcon = direction < 0 ? IconActionChevronLeft16 : IconActionChevronRight16;
  const style = direction < 0 ? { left: '-20px' } : { right: '-20px' };

  return (
    <div
      className={clsx(
        styles['container'],
        direction < 0 ? styles['container--left'] : styles['container--right'],
        containerClass,
      )}
      data-testid="seria-plus-carousel-arrow-container"
      style={style}
      onClick={onClick}
    >
      <div className={styles['arrow']}>
        <RoundButton
          data-testid="seria-plus-carousel-arrow-button"
          icon={<ArrowIcon color="icon-secondary-default" />}
          title={direction < 0 ? 'Назад' : 'Вперёд'}
        />
      </div>
    </div>
  );
};
